import { InsightFilterEnum } from 'appRedux/models/favoritesModels';

export const allMetrics = [
  { id: InsightFilterEnum.ReturnToPlayer, label: 'RTP' },
  { id: InsightFilterEnum.Jackpot, label: 'Jackpots' },
  { id: InsightFilterEnum.MoneyPlayed, label: '$ Played' },
  { id: InsightFilterEnum.MoneyWon, label: '$ Won' },
  // Compare row label only — Explore drawer pill stays "Popular" (InsightInline).
  { id: InsightFilterEnum.Spins, label: 'Spins' },
  { id: InsightFilterEnum.AverageWonPerSpin, label: 'Wins/Spin' },
  { id: InsightFilterEnum.NonJackpotWonPerSpin, label: 'W/S-J' },
  { id: InsightFilterEnum.JackpotWonPerSpin, label: 'JW/S' },
];
